export const userColumns = [
  { field: "userName", headerName: "UserName", width: 100 },
  { field: "orderPaymentID", headerName: "OrderPayID", width: 100 },
  { field: "orderID", headerName: "OrderID", width: 100 },
  { field: "contact", headerName: "Contact", width: 100 },
  { field: "mailID", headerName: "Mail-ID", width: 100 },
  {field: "duration", headerName: "Duration", width: 100},
  {field: "couponID", headerName: "CouponId", width: 100},
  {field: "copuanTitle", headerName: "copuanTitle", width: 100},
  {field: "branchName", headerName: "Branch", width: 100},
  {field: "location", headerName: "Location", width: 100},
  {
    field: "amount",
    headerName: "Amount",
    width: 120,
  },
  {
    field: "date",
    headerName: "date",
    width: 120,
  }
];
